import { styled } from '@mui/system';
import { Box, Card } from '@mui/material';

export const StatusCard = styled(Card)({
  borderRadius: 6,
  marginTop: 10,
  marginBottom: 4,
  width: '100%',
  boxShadow: 3
});

export const StatusHeading = styled('span')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
  fontWeight: theme.typography.fontWeightBold,
  color: '#004F9F',
  alignSelf: 'center',
  marginLeft: 14
}));

const statusBackgrounds = {
  CALCULATED: 'linear-gradient(125deg, rgb(242, 242, 242) 90%, rgb(21, 101, 192) 100%)',
  REJECTED: 'linear-gradient(125deg, rgb(242, 242, 242) 90%, rgb(246,104,94) 100%)',
  APPROVED: 'linear-gradient(125deg, rgb(242, 242, 242) 90%, rgb(165, 255, 168) 100%)',
  DOWNLOADED: 'linear-gradient(125deg, rgb(242, 242, 242) 90%, rgb(165, 255, 168) 100%)',
};

export const StatusBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'status',
})(({ status }) => ({
  minHeight: 64,
  width: '100%',
  padding: 6,
  display: 'flex',
  backgroundColor: 'rgba(242, 242, 242, 1)',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: statusBackgrounds[status] || undefined,
}));
